import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { ContentBlock, FormBlock, PortalSupport } from 'components'
import { RegisterForm } from '../forms'
import * as Types from 'types'
import { useCommunity, displaySubmitFailure } from 'utils'
import { SIGN_IN_PATH, PARTNER_PORTAL_PATH } from 'config'
import * as apiActions from 'api-actions'
import * as actions from '../actions'
import PropTypes from 'prop-types'
import { selectors as globalSelectors } from 'global-reducer'

const propTypes = {
  signUp: PropTypes.func.isRequired,
  signUpSuccess: PropTypes.func.isRequired,
  disciplines: PropTypes.arrayOf(Types.discipline),
}

const defaultProps = {}

function Register({ signUp, signUpSuccess, disciplines }) {
  const community = useCommunity()

  return (
    <ContentBlock>
      <FormBlock>
        <RegisterForm
          onSubmit={(params) =>
            signUp(params).then((response) => ({ ...params, ...response }))
          }
          onSubmitSuccess={(response) =>
            signUpSuccess({
              ...response,
              redirectUrl: `/${SIGN_IN_PATH}/account-pending-confirmation`,
            })
          }
          disciplines={disciplines}
          onSubmitFail={displaySubmitFailure}
          initialValues={{ portal: PARTNER_PORTAL_PATH }}
        />
      </FormBlock>
      <PortalSupport
        supportEmail={community.partnerSupportEmail}
        portalType={Types.PORTAL.PARTNER_PORTAL}
      />
    </ContentBlock>
  )
}

Register.propTypes = propTypes
Register.defaultProps = defaultProps

function mapStateToProps(state) {
  return {
    disciplines: globalSelectors.disciplines(state),
  }
}

const mapDispatchToProps = {
  signUp: apiActions.signUp,
  signUpSuccess: actions.signUpSuccess,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(Register)
